module.exports = __webpack_public_path__ + "static/img/suomalaistapalvelua_suomi_musta_rgb.b05ac9d.png";